module.exports = __WEBPACK_EXTERNAL_MODULE_50__;


//////////////////
// WEBPACK FOOTER
// external {"root":"@material/radio/dist/mdc.radio","commonjs2":"@material/radio/dist/mdc.radio","commonjs":"@material/radio/dist/mdc.radio","amd":"@material/radio/dist/mdc.radio","umd":"@material/radio/dist/mdc.radio"}
// module id = 50
// module chunks = 0